import { useState } from 'react';
import { login } from './api';
import { CHANGELOG } from './Dashboard';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const sessionExpired = sessionStorage.getItem('session_expired') === '1';
  if (sessionExpired) sessionStorage.removeItem('session_expired');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(username, password);
      localStorage.setItem('token', res.data.access_token);
      onLogin();
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        setError('Invalid credentials. Please try again.');
      } else if (status === 403) {
        setError(err.response?.data?.detail || 'Account is disabled. Contact your administrator.');
      } else if (status === 423) {
        setError(err.response?.data?.detail || 'Account is temporarily locked. Please try again later.');
      } else if (status === 429) {
        setError('Too many login attempts. Please wait a moment and try again.');
      } else {
        setError('Login failed. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.bg} />
      <div style={styles.card}>
        <div style={styles.logo}>
          <div style={styles.logoIcon}>MP</div>
          <div>
            <div style={styles.logoTitle}>CSH - QSSE Department</div>
          </div>
        </div>
        <div style={styles.divider} />
        {sessionExpired && (
          <div style={styles.sessionExpired}>Your session has expired. Please sign in again.</div>
        )}
        <form onSubmit={handleSubmit}>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>USERNAME</label>
            <input
              style={styles.input}
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter username"
              autoFocus
            />
          </div>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>PASSWORD</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>
          {error && <div style={styles.error}>{error}</div>}
          <button style={{...styles.btn, opacity: loading ? 0.7 : 1}} type="submit" disabled={loading}>
            {loading ? 'AUTHENTICATING...' : 'SIGN IN'}
          </button>
        </form>
        <div style={styles.footer}>Platform {CHANGELOG[0]?.version || 'v1.0.0'} Designed with Love by MDG</div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', position: 'relative', overflow: 'hidden',
    background: 'var(--navy)',
  },
  bg: {
    position: 'absolute', inset: 0,
    background: 'radial-gradient(ellipse at 20% 50%, rgba(232,0,29,0.06) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(201,168,76,0.04) 0%, transparent 50%)',
    pointerEvents: 'none',
  },
  card: {
    background: 'var(--navy-mid)', border: '1px solid var(--navy-border)',
    borderRadius: '16px', padding: '48px', width: '100%', maxWidth: '420px',
    position: 'relative', zIndex: 1,
    boxShadow: '0 32px 80px rgba(0,0,0,0.5)',
  },
  logo: { display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '32px' },
  logoIcon: {
    width: '48px', height: '48px', background: 'var(--red)', borderRadius: '10px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: 'var(--font-mono)', fontWeight: '500', fontSize: '14px', color: 'white',
  },
  logoTitle: { fontSize: '18px', fontWeight: '700', color: 'var(--white)' },
  divider: { height: '1px', background: 'var(--navy-border)', marginBottom: '32px' },
  fieldGroup: { marginBottom: '20px' },
  label: {
    display: 'block', fontSize: '10px', fontWeight: '600', letterSpacing: '2px',
    color: 'var(--grey)', marginBottom: '8px', fontFamily: 'var(--font-mono)',
  },
  input: {
    width: '100%', background: 'var(--navy)', border: '1px solid var(--navy-light)',
    borderRadius: '8px', padding: '12px 16px', color: 'var(--white)',
    fontSize: '14px', outline: 'none', fontFamily: 'var(--font-mono)',
  },
  error: {
    background: 'var(--red-glow)', border: '1px solid rgba(232,0,29,0.3)',
    borderRadius: '8px', padding: '12px 16px', fontSize: '13px',
    color: '#ff6b7a', marginBottom: '20px',
  },
  btn: {
    width: '100%', background: 'var(--red)', border: 'none', borderRadius: '8px',
    padding: '14px', color: 'white', fontSize: '13px', fontWeight: '700',
    letterSpacing: '2px', cursor: 'pointer', marginTop: '8px',
  },
  sessionExpired: {
    background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.3)',
    borderRadius: '8px', padding: '12px 16px', fontSize: '13px',
    color: '#c9a84c', marginBottom: '20px',
  },
  footer: {
    textAlign: 'center', fontSize: '11px', color: 'var(--grey)',
    marginTop: '32px', fontFamily: 'var(--font-mono)',
  },
};
